import React from 'react'
import { Row, Col } from 'antd'
import { OrderData } from '../../../../services/api/orders'
import { Property } from '../../../../components'
import { Status } from './Status'
import { displayAmount } from '../../../../utils/formatter'

type Props = {
  order: OrderData
}

export const Order: React.FunctionComponent<Props> = ({ order }) => {
  return (
    <Row>
      <Col span={12}>
        <Property label="Идентификатор">{order.id}</Property>
        <Property label="Kupi UUID">{order.kupiOrderUuid}</Property>
        <Property label="PNR GDS">{order.providerPnr}</Property>
        <Property label="PNR AK">{order.pnr}</Property>
        <Property label="PCC">{order.pcc}</Property>
        <Property label="Provider">{order.provider}</Property>
      </Col>
      <Col span={12}>
        <Property label="Номер">{order.number}</Property>
        <Property label="Цена">{displayAmount(order.priceAmount)}</Property>
        <Property label="Статус" copiableValue={order.status}>
          <Status status={order.status} />
        </Property>
        <Property label="Тип бронирования">{order.flight.cabinClass}</Property>
      </Col>
    </Row>
  )
}
